<template>
  <div>
    <ListComponent />
  </div>
</template>

<script>
import ListComponent from "@/components/YatriRefund/refund-list.vue";

export default {
  components: { ListComponent },
};
</script>
